import React from 'react';
import { Link } from 'react-router-dom';
import { AboutMeData } from '../../Store';
import './abouthero.scss'

const AboutHero = () => {

    const aboutMe = AboutMeData;
    return (
        <div className="about-hero">
            <div className="container">
                <div className="hero-flex">
                <div className="left">
                    <h5>Hola, My name is</h5>
                        <h1>Ariful Mowla</h1>
                        
                        {/* <h1>Implement Your Dream In Web.</h1> */}
                    <ul>
                        <li>Web Developer</li>
                        <li>Security expert</li>
                    </ul>
                        <p>{aboutMe.shortDes}</p>
                        <Link to="/contact" className="btn btn-blank" role="button">
        
                        Get In Touch
          
                    </Link>
                    </div>
                    <div className="right">
                        <div className="img-limit">
                            <div className="hero-img"><img src={aboutMe.image} alt="about"/></div>
                        </div>
                    </div>
            </div>
            </div>
        </div>
    );
};

export default AboutHero;